<template>
  <div class="content-image">
    <figure v-if="data && data.image" class="image-figure" :class="[`-${data.display}`]">
      <Image v-if="data.image.responsiveImage" class="image" :data="data.image.responsiveImage" object-fit="cover" />
      <figcaption v-if="data.caption" class="caption copy-small">{{ data.caption }}</figcaption>
    </figure>
  </div>
</template>

<script setup lang="ts">
import { Image } from 'vue-datocms';
import type { ContentImageFragment } from '#gql';

defineProps<{
  data: ContentImageFragment;
}>();
</script>

<style scoped lang="scss">
.content-image {
  @include grid-layout();

  & {
    padding: var(--site-inner-padding);
    width: 100%;
    max-width: var(--site-max-width);
    padding-top: var(--spacing-2xs);
    padding-bottom: var(--spacing-2xs);
  }

  .image-figure {
    width: 100%;
    grid-column: 1 / -1;

    &.-big {
      @media (--md), (--lg) {
        grid-column: 3 / 23;
      }
    }

    &.-small {
      @media (--md), (--lg) {
        grid-column: 5 / 21;
      }
    }

    > .image {
      aspect-ratio: 16 / 9;
      margin-bottom: var(--spacing-4xs);
    }
  }
}
</style>
